import React, { ChangeEvent } from 'react';
import {
	Select,
	TextBlock,
	Option,
	TextField
} from 'neon-design-system';
import { Grid } from '@material-ui/core';
import { FormControl } from '../../../utils/form.utils';

interface StripeBusinessAddressProps {
	addressLine1FormControl: FormControl<string>;
	addressLine2FormControl: FormControl<string>;
	addressStateFormControl: FormControl<string>;
	addressCityFormControl: FormControl<string>;
	addressPostcodeFormControl: FormControl<string>;
	businessCountryFormControl: FormControl<Option | undefined>;
	readonlyCountryOption: Option;
	removeBillingAddressErrorMessage: () => void;
}

export const StripeBusinessAddress = ({
	addressLine1FormControl,
	addressLine2FormControl,
	addressStateFormControl,
	addressCityFormControl,
	addressPostcodeFormControl,
	businessCountryFormControl,
	readonlyCountryOption,
	removeBillingAddressErrorMessage
}: StripeBusinessAddressProps) => {
	return (
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<TextBlock styleName="footnote">
					We need your business details for invoicing purposes.
				</TextBlock>
			</Grid>
			<Grid item xs={12}>
				<TextField
					id={'address-line1-input'}
					fullWidth
					error={addressLine1FormControl?.showError}
					errorText={addressLine1FormControl?.validationMessage}
					type="text"
					label="Address line 1"
					autoComplete="off"
					value={addressLine1FormControl?.value}
					onBlur={addressLine1FormControl?.handleBlur}
					onChange={(e: ChangeEvent<any>): void => {
						const val: string = e?.target?.value;
						addressLine1FormControl?.setValue(val);
						removeBillingAddressErrorMessage();
					}}
				/>
			</Grid>
			<Grid item xs={12}>
				<TextField
					id={'address-line2-input'}
					fullWidth
					error={addressLine2FormControl?.showError}
					errorText={addressLine2FormControl?.validationMessage}
					type="text"
					label="Address line 2"
					autoComplete="off"
					value={addressLine2FormControl?.value}
					onBlur={addressLine2FormControl?.handleBlur}
					onChange={(e: ChangeEvent<any>): void => {
						const val: string = e?.target?.value;
						addressLine2FormControl?.setValue(val);
						removeBillingAddressErrorMessage();
					}}
				/>
			</Grid>
			<Grid item xs={12} lg={6}>
				<TextField
					id={'address-city-input'}
					fullWidth
					error={addressCityFormControl?.showError}
					errorText={addressCityFormControl?.validationMessage}
					type="text"
					label="City"
					autoComplete="off"
					value={addressCityFormControl?.value}
					onBlur={addressCityFormControl?.handleBlur}
					onChange={(e: ChangeEvent<any>): void => {
						const val: string = e?.target?.value;
						addressCityFormControl?.setValue(val);
						removeBillingAddressErrorMessage();
					}}
				/>
			</Grid>
			<Grid item xs={12} lg={6}>
				<TextField
					id={'address-state-input'}
					fullWidth
					error={addressStateFormControl?.showError}
					errorText={addressStateFormControl?.validationMessage}
					type="text"
					label="State"
					autoComplete="off"
					value={addressStateFormControl?.value}
					onBlur={addressStateFormControl?.handleBlur}
					onChange={(e: ChangeEvent<any>): void => {
						const val: string = e?.target?.value;
						addressStateFormControl?.setValue(val);
						removeBillingAddressErrorMessage();
					}}
				/>
			</Grid>
			<Grid item xs={12} lg={6}>
				<TextField
					id={'address-postcode-input'}
					fullWidth
					error={addressPostcodeFormControl?.showError}
					errorText={addressPostcodeFormControl?.validationMessage}
					type="text"
					label="Postal code"
					autoComplete="off"
					value={addressPostcodeFormControl?.value}
					onBlur={addressPostcodeFormControl?.handleBlur}
					onChange={(e: ChangeEvent<any>): void => {
						const val: string = e?.target?.value;
						addressPostcodeFormControl?.setValue(val);

						if (addressPostcodeFormControl.showError) {
							removeBillingAddressErrorMessage();
						}
					}}
				/>
			</Grid>
			<Grid item xs={12} lg={6}>
				<Select
					id={'business-country-readonly-select'}
					size="medium"
					menuPlacement="bottom"
					label="Country"
					value={readonlyCountryOption}
					onBlur={businessCountryFormControl?.handleBlur}
					error={businessCountryFormControl?.showError}
					errorText={businessCountryFormControl?.validationMessage}
					onChange={(opt: Option): void => {
						businessCountryFormControl?.setValue(opt);
					}}
					options={[readonlyCountryOption]}
					clearable={false}
					disabled={true}
				/>
			</Grid>
		</Grid>
	)
}
